module.exports = __webpack_public_path__ + "img/lx1.96902b6f.png";